import React, { useState } from "react";
import { FaEllipsisV } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import {team} from './mock'
const PersonsDrawer = ({})=>{
    const [ status, setStatus ] = useState(true)
    const close = () => setStatus(!status)
    const closeModal = (e) => {
        e.preventDefault()
        close(false);
      } 

    return status ? (
        <React.Fragment> 
            <title>People Drawer</title>
        <div className="persons-drawer">
            <div className="team-heading">
                <div className="head">
                    <h3 className="title">Team</h3>
                    <a href="##" onClick={(e)=>{
                        e.preventDefault()
                        closeModal(e)
                    }} >
                        <FiX />
                    </a>
                </div>
                <ul className="team-tabs">
                    <li>All</li>
                    <li>Online</li>
                    <li>Offline</li>
                </ul>
            </div>
    
            <ul className="team-persons">
                {team.map((person)=>{
                    return <li>
                        <a href="##">
                            <div className="flex">
                                <img src={'/assets/images/'+person.img} className={`avatar ${person.online}`}/>
                                <div>
                                    <h3 className="name">{person.name}</h3>
                                    <p className="slug">{person.username}</p>
                                </div>
                            </div>
                            <div>
                                <FaEllipsisV />
                            </div>
                        </a>
                    </li>
                })}
            </ul>
        </div>
        <div 
            className="overlay"  
            onClick={(e)=>closeModal(e)}
        ></div>
    </React.Fragment>


    ) : <React.Fragment></React.Fragment>
}

export default PersonsDrawer;

